import React, { Component } from "react";
import axios from "axios";
import * as d3 from "d3";
import LoadingIcon from "./icons/LoadingIcon";
import ModelBlock from "./blocks/ModelBlock";

class MainModels extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domain: this.props.domain,
            show_loading: true,
            selected_metric: "AER",
            datasets: [],
            model: null

        }
    }


    componentDidMount() {
        const {domain} = this.state;
        const query = new URLSearchParams(window.location.search);
        const dataset_id = query.get('m');
        var url = domain+"api/model?m="+dataset_id
        axios.get(url)
            .then(res => {
                this.setState({
                    model:res.data.model,
                    show_loading: false,
                    models_colors: this.getColors(),
                    datasets: res.data.datasets,

                },()=>{this.drawBarChart();
                });
            });

    }

    setSelectedModel = (model_id, ds_id)=>{
        window.location.href="main?m="+model_id+"&ds="+ds_id;
    }

// Drawing Charts
    drawBarChart = ()=>{
        const {datasets, selected_metric } = this.state
        const models_colors = this.getColors() //models_colors===null?:models_colors

        const max_value = {"AER": 1, "precision": 1, "recall": 1, "f1": 1,
            "pac": 1, "coverage": 1}

        let margin = {top: 10, right: 20, bottom: 130, left: 40};
        let svgWidth = 500, svgHeight = 400;
        let height = svgHeight- margin.top- margin.bottom, width = svgWidth - margin.left - margin.right;

        let x = d3.scaleBand().rangeRound([0, width]).padding(0.2),
            y = d3.scaleLinear().rangeRound([height, 0]);


        x.domain(datasets);
        y.domain([0, max_value[selected_metric]]); // d3.max(sourceCount, function(d) { return d/300; })]

        // append the svg object to the body of the page
        d3.select("#barChart_main").select("svg").remove();
        var svg = d3.select("#barChart_main")
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .style("display", "block")
            .style("margin", "auto")
            .append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

        let parent = this;

        var xis = svg.append("g")
            .attr("class", "axis axis--x")
            .attr("transform", "translate(0," + (height ) + ")")
            .call(d3.axisBottom(x).ticks(datasets.length)
            .tickFormat((d, i) => {return d.dataset.title}));
        if(datasets.length > 4){
            xis.selectAll("text")
                .style("text-anchor", "end")
                .attr("dx", "-.8em")
                .attr("dy", ".15em")
                .attr("transform", "rotate(-65)");
        }


        svg.append("g")
            .attr("class", "axis axis--y")
            .attr("id", "axis_y")
            //.attr("transform", "translate(-5, 0)")
            .call(d3.axisLeft(y).ticks(5))

        d3.select("#axis_y")
            .append("text")
            .attr("transform", "rotate(-90) translate(-80, -30)")
            .style("fill", "#333")
            .text(selected_metric.toUpperCase());

        // Create rectangles

        let bars = svg.selectAll('.bar')
            .data(datasets)
            .enter()
            .append("g");

        bars.append('rect')
            .attr('class', 'bar')
            .attr("x", function(d) { return x(d); })
            .attr("y", function(d) {return y(d.stat[selected_metric]); })
            .attr("id", function(d) { return "mainBarChart_" +d.model_id; })
            .attr("fill", function(d){return models_colors[d.title] })
            //.style("stroke", "black").style("stroke-width", (d)=>{return model1===d?2:0})
            .attr("width", x.bandwidth())
            .attr("height", function(d) { return height - y(d.stat[selected_metric]); })
            .on("click", (d, a)=>{parent.setSelectedModel(a.model_id, a.dataset.id)});

        bars.append("text")
            .text(function(d) {
                return d.stat[selected_metric];
            })
            .attr("x", function(d){
                return x(d) + x.bandwidth()/2;
            })
            .attr("y", function(d){
                return  y(d.stat[selected_metric]) - 5;
            })
            .attr("font-family" , "sans-serif")
            .attr("font-size" , "10px")
            .attr("fill" , "black")
            .attr("text-anchor", "middle");
    }

    getColors = ()=>{
        let keys = []
        for(let ds of this.state.datasets){
            keys.push(ds.title)
        }
        var getColor = d3.scaleOrdinal().domain(keys)
            .range(['#4e79a7', '#f28e2c', '#e15759', '#76b7b2', '#af7aa1', '#ff9da7', '#9c755f', '#bab0ab', '#edc949'])
        let datasets_colors = {};
        for(let ds of this.state.datasets){
            let key = ds.title;
            datasets_colors[key] = getColor(key)
        }
        return datasets_colors
    }

    changeSelectedMetric = (metric) =>{
        this.setState({
            selected_metric: metric
        }, ()=>{
            this.drawBarChart();
        })
    }

    styleSelectedBarchartBar = ()=>{
        d3.selectAll("[id^='mainBarChart_']").attr("stroke-width", 0).attr("stroke", "black");
        d3.select("#mainBarChart_"+this.state.selected_model).attr("stroke-width", 2).attr("stroke", "black");
    }


    render() {
        const {model, show_loading, selected_metric}  = this.state


        let selected_metric_css = "px-2 py-1 bg-neutral-700 rounded text-xs text-white m-1 hover:bg-gray-800"
        let default_metric_css = "px-2 py-1 border border-gray-300 rounded text-xs text-gray-600 m-1  hover:bg-gray-200"


        return (
            <div>
                {show_loading?
                    <div className="flex m-auto justify-center"><LoadingIcon /></div>:

                    <div>
                        <ModelBlock model={model}/>

                        <div>
                            <div className="border bg-white border-gray-200 mb-5 p-3 rounded-lg shadow-lg">
                               <div className="m-auto flex">
                                    <div className="md:w-full lg:w-1/2">
                                        <div className="text-xs text-left">Select a model:</div>
                                        <div>
                                            <button className={selected_metric==="AER"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("AER")}}>AER</button>
                                            <button className={selected_metric==="precision"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("precision")}}>Precision</button>
                                            <button className={selected_metric==="recall"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("recall")}}>Recall</button>
                                            <button className={selected_metric==="f1"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("f1")}}>F1</button>
                                            <button className={selected_metric==="coverage"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("coverage")}}>Coverage</button>
                                            <button className={selected_metric==="pac"?selected_metric_css:default_metric_css}
                                                    onClick={()=>{this.changeSelectedMetric("pac")}}>PAC</button>
                                        </div>
                                        {/*<RangeSlider />*/}
                                        <div  id="barChart_main">

                                        </div>
                                        <div className="mt-5">
                                            {/*{models.map(model=>{*/}
                                            {/*    return <span className="m-2 px-2 py-1 border border-gray-300 rounded text-xs " key={"model_toggle_button_"+model}>{model}</span>*/}
                                            {/*})}*/}

                                        </div>
                                    </div>

                               </div>
                        </div>


                        </div>
                    </div>
                }
            </div>
        )
    }

}

export default MainModels;